import { render, staticRenderFns } from "./FluidStudyBend.vue?vue&type=template&id=d8af15b0&scoped=true&"
import script from "./FluidStudyBend.vue?vue&type=script&lang=js&"
export * from "./FluidStudyBend.vue?vue&type=script&lang=js&"
import style0 from "./FluidStudyBend.vue?vue&type=style&index=0&id=d8af15b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8af15b0",
  null
  
)

export default component.exports